(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/common/utils.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/common/utils.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const productMapping = svs.numbergames.productMapping;
const PROLONG_WAGERS_PARAMS = svs.numbergames.prolong_game.common.constants.PROLONG_WAGERS_PARAMS;
const checkSavedWagerInfo = wagerId => {
  const urlParams = new URLSearchParams(window.location.search);
  const prepCount = PROLONG_WAGERS_PARAMS.prepCount,
    prepDays = PROLONG_WAGERS_PARAMS.prepDays,
    prepId = PROLONG_WAGERS_PARAMS.prepId;
  if (urlParams.get(prepId) === wagerId) {
    var _urlParams$get;
    return {
      isExisting: true,
      selectedDays: (_urlParams$get = urlParams.get(prepDays)) === null || _urlParams$get === void 0 ? void 0 : _urlParams$get.split(/[-,]/),
      drawCount: urlParams.get(prepCount)
    };
  }
  return {};
};
const buildProlongHref = _ref => {
  let productName = _ref.productName,
    wagerId = _ref.wagerId,
    syndicateId = _ref.syndicateId,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options,
    isPay = _ref.isPay,
    getAfterChangeReturnUrl = _ref.getAfterChangeReturnUrl;
  const product = productMapping.getBrandingClass(productName);
  const urlParams = Object.entries(options).map(_ref2 => {
    let _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(key, "=").concat(value);
  });
  if (syndicateId) {
    urlParams.push("syndicateId=".concat(syndicateId));
  }
  if (isPay) {
    urlParams.push('pay=true');
  }
  const returnUrl = getAfterChangeReturnUrl === null || getAfterChangeReturnUrl === void 0 ? void 0 : getAfterChangeReturnUrl();
  if (returnUrl && typeof returnUrl === 'string') {
    urlParams.push("returnUrl=".concat(encodeURIComponent(returnUrl)));
  }
  return "/".concat(product, "/forlang-mina-spel/").concat(wagerId, "?").concat(urlParams.join('&'));
};
const generateSubscriptionHref = _ref4 => {
  var _productMapping$getDa;
  let productName = _ref4.productName,
    wagerId = _ref4.wagerId,
    selectedDays = _ref4.selectedDays;
  const options = {
    dragningar: 'prenumerera',
    dag: selectedDays.length > 1 ? 'b' : (_productMapping$getDa = productMapping.getDay(selectedDays[0])[0]) === null || _productMapping$getDa === void 0 ? void 0 : _productMapping$getDa.toLowerCase()
  };
  return buildProlongHref({
    productName,
    wagerId,
    options,
    isPay: true
  });
};
const onboardingClosingAction = setIsOpen => {
  const closeCarousel = event => {
    event.preventDefault();
    setIsOpen(false);
  };
  const carouselItems = document.querySelectorAll('.ui-carousel-item');
  const lastAdInCarousel = carouselItems[carouselItems.length - 1];
  if (lastAdInCarousel) {
    const closeButtonArea = lastAdInCarousel.querySelectorAll('.ui-carousel-actions')[0];
    if (closeButtonArea) {
      closeButtonArea.addEventListener('click', closeCarousel);
    }
  }
  return () => {
    if (lastAdInCarousel) {
      const closeButtonArea = lastAdInCarousel.querySelectorAll('.ui-carousel-actions')[0];
      if (closeButtonArea) {
        closeButtonArea.removeEventListener('click', closeCarousel);
      }
    }
  };
};
setGlobal('svs.numbergames.prolong_game.common.utils', {
  buildProlongHref,
  checkSavedWagerInfo,
  generateSubscriptionHref,
  onboardingClosingAction
});

 })(window);